/**
 * External service URLs for Grokio Communities
 */

/**
 * Public app store listings for the Grokio Communities mobile app
 */
export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/us/app/grokio-communities/id1451973452',
  android: 'https://play.google.com/store/apps/details?id=com.grokiolabs.Grokio',
} as const;

/**
 * Billing and subscription information URLs (community-specific)
 */
export const BILLING_URLS = {
  grommr: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/22717a93-47d9-4366-8860-2e0d46238a55/article/1707048961',
  feabie: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/22717a93-47d9-4366-8860-2e0d46238a55/article/1706524673',
  chasabl: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/22717a93-47d9-4366-8860-2e0d46238a55/article/1705508865',
  ferzu: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/22717a93-47d9-4366-8860-2e0d46238a55/article/1704361985',
  pupspace: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/22717a93-47d9-4366-8860-2e0d46238a55/article/736034817',
} as const;

/**
 * Plan details / knowledge-base articles (community-specific, platform-specific)
 */
export const PLAN_INFO_URLS: Record<string, { web: string; native: string }> = {
  grommr: {
    web: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3213819917?source=shareable-url',
    native: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3234955267?source=shareable-url',
  },
  feabie: {
    web: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3213361161?source=shareable-url',
    native: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3235217409?source=shareable-url',
  },
  chasabl: {
    web: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3212967959?source=shareable-url',
    native: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3235119116?source=shareable-url',
  },
  ferzu: {
    web: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3213951047?source=shareable-url',
    native: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3235381249?source=shareable-url',
  },
  pupspace: {
    web: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3213557791?source=shareable-url',
    native: 'https://grokio.atlassian.net/servicedesk/customer/kb/view/3234856977?source=shareable-url',
  },
};

/**
 * Support and help desk URLs
 */
export const SUPPORT_URLS = {
  /**
   * Atlassian Service Desk URLs
   */
  atlassian: {
    /**
     * Base URL for the service desk portal
     */
    basePortal: 'https://grokio.atlassian.net/servicedesk/customer/portal/4',
    
    /**
     * Support and help resources
     */
    support: {
      /**
       * General help center and support ticket submission
       */
      helpCenter: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/group/-1',
      
      /**
       * New Platform Feedback form
       */
      newPlatformFeedback: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/group/4/create/11175',
      
      /**
       * Billing support ticket creation form
       */
      billingSupport: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/group/4/create/10059',
    },
    
    /**
     * Legal and policy documents
     */
    legal: {
      /**
       * Terms of Use
       */
      termsOfUse: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/9630ea01-2d5c-4b27-8406-acde947fe307/article/5505076',
      
      /**
       * Privacy Policy
       */
      privacyPolicy: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/9630ea01-2d5c-4b27-8406-acde947fe307/article/65667073',
      
      /**
       * Community rules and conduct policies
       */
      communityRules: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/9e045c7a-d475-45c7-8f3f-90779ada1949/article/10551297',
    },
    
    /**
     * Knowledge base articles
     */
    articles: {
      /**
       * How-to guide for unlocking private photos
       */
      unlockPrivatePhotos: 'https://grokio.atlassian.net/servicedesk/customer/portal/4/topic/31643be6-a388-431b-babf-5b0878975193/article/10453004',
    },
  },
} as const;

